import { Component, computed, OnInit, Signal, inject } from '@angular/core';
import { NgClass } from '@angular/common';
import { CircleGraphComponent } from '../../../../../shared/components/circle-graph/circle-graph.component';
import { TransactionsWidget } from '../../../../../_interfaces/dashboard.interface';
import { DashboardApiService } from '../../../../../_services/dashboard-api-service/dashboard-api.service';
import { DashboardWidgetBaseComponent } from '../dashboard-widget-base.component';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { AppSelectors } from '../../../../../store/app/app.selectors';
import { Store } from '@ngxs/store';
import { TransactionsApiService } from '../../../../../_services/transactions-service/transactions-api.service';
import { ToastService } from '../../../../../_services/toast-service/toast.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalComponent } from '../../../../../shared/components/modals/modal/modal.component';
import { getSecondsFromThrottleMsg } from '../../../../../shared/utils/resend-btn-utils';
import { formatDuration } from '../../../../../shared/utils/general-utils';

@Component({
  selector: 'app-health-status-widget',
  imports: [CircleGraphComponent, NgClass],
  templateUrl: './health-status-widget.component.html',
  styleUrl: './health-status-widget.component.scss',
})
export class HealthStatusWidgetComponent extends DashboardWidgetBaseComponent implements OnInit {
  readonly dashboardApiService = inject(DashboardApiService);
  readonly transactionsApiService = inject(TransactionsApiService);
  readonly toastService = inject(ToastService);
  readonly modalService = inject(NgbModal);
  readonly store = inject(Store);
  readonly router = inject(Router);

  protected isSending = false;
  protected limitReached = false;
  readonly bizId = computed(() => this.store.selectSnapshot(AppSelectors.bizId));

  protected transactionsWidgetData!: TransactionsWidget | undefined;
  protected healthPercentage: Signal<number> = computed(() => {
    if (this.transactionsWidgetData) {
      return (+this.transactionsWidgetData.no_receipt / +this.transactionsWidgetData.transactions) * 100;
    } else {
      return 0;
    }
  });

  ngOnInit() {
    this.subscriptions.add(
      this.dashboardApiService.getTransactionsWidgetDetails().subscribe({
        next: (res) => {
          if (res) {
            this.transactionsWidgetData = res;
            this.isLoading = false;
          }
        },
      }),
    );
  }

  sendReminders() {
    const modalRef = this.modalService.open(ModalComponent, {
      centered: true,
      size: 'md',
    });
    modalRef.componentInstance.title = 'Send reminders';
    modalRef.componentInstance.bodyText =
      'This will send push notification reminders to all cardholders with outstanding receipts. Continue?';
    modalRef.componentInstance.buttonTextDismiss = 'Cancel';
    modalRef.componentInstance.buttonTextAction = 'Continue';
    modalRef.closed.subscribe({
      next: () => {
        this.isSending = true;
        this.transactionsApiService.sendTransactionsReminders(this.bizId()).subscribe({
          next: () => {
            this.toastService.show(
              `Reminders sent for ${this.transactionsWidgetData?.no_receipt} receipts not captured`,
            );
            this.limitReached = true;
            this.isSending = false;
          },
          error: (err: HttpErrorResponse) => {
            if (err.status === 429) {
              this.limitReached = true;
              const seconds = getSecondsFromThrottleMsg(err.error?.detail);
              const timeframe = seconds !== null ? `in ${formatDuration(seconds)}.` : `later.`;
              this.toastService.show(`Reminders were already sent recently. Please try again ${timeframe}`);
            } else if (err.status === 430) {
              this.toastService.show('You do not have permission to send reminders for this company.');
            } else if (err.status > 430) {
              this.toastService.show('Something went wrong. Please try again.');
            }
            this.isSending = false;
          },
        });
      },
    });
  }
}
